// Habillage des écrans hôtesse / responsable : palette Supermont.
export const APP_NAME = 'Lancer du palet';
export const LOGO = '/images/logo-supermont.png';

export const C = {
  primary: '#1565c0',
  primaryDark: '#0d47a1',
  primaryLight: '#1976d2',
  accent: '#42a5f5',
  bg: '#ffffff',
  bgLight: '#f4f6f9',
  border: '#dee2e6',
  gradient: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
  textMain: '#1a1a1a',
  textSub: '#555',
};

export const MODE_LABELS = { whatsapp: 'WhatsApp', direct: 'Direct', qr_code: 'QR Code' };
export const LINE_LABELS = { plate: 'Plate', petillante: 'Pétillante' };

export function formatPhone(phone) {
  if (!phone) return '-';
  const d = phone.replace(/\D/g, '');
  if (d.startsWith('237') && d.length === 12) return `+${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 9)} ${d.slice(9)}`;
  return phone;
}

// Lien WhatsApp préparé côté navigateur : l'adresse du jeu est celle du site affiché.
export function whatsappLink(phone, text) {
  return `https://wa.me/${(phone || '').replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;
}

export function gameUrl(path) {
  return `${window.location.origin}${path}`;
}

export function inviteMessage(name, url) {
  return `Bonjour ${name} ! 🥏 Lancez le palet Supermont et tentez de gagner des lots ! 🎁 ${url}`;
}
